/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  API,
  defaultLimitPagination,
  get,
  paymentMethods,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import { debounce } from "lodash";
import MainBody from "../../components/MainBody/MainBody";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../components/Pagination";
import sortCaret from "../../components/SortCaret";
import {
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import { useTrust } from "../../lib/context/TrustContext";
import { cn } from "../../lib/utils";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { LawyerConditon } from "../../lib/PermissionConditions";

const ReceiptItemsBasedOnSubAsset = ({
  initialSubAssetId,
  is_payment,
  paymentId,
}) => {
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const [receiptList, setReceiptsList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const { trustId } = useTrust();
  const { organizationData } = useOrganization();

  const fetchReceipts = useCallback(
    async (passLimit, passPage) => {
      if (trustId) {
        try {
          setLoading(true);
          const { data } = await get(
            `${API.GET_RECEIPT_ITEMS}?limit=${
              passLimit ? passLimit : limit ? limit : defaultLimitPagination
            }&page=${passPage ? passPage : page ? page : 1}&search=${
              searchParam ? searchParam : ""
            }&sort_column=${sortField ? sortField : ""}&sort_order=${
              sortOrder ? sortOrder : ""
            }&trust_id=${trustId ? trustId : ""}&sub_asset_id=${
              initialSubAssetId ? initialSubAssetId : ""
            }${is_payment ? "&is_payment=1" : ""}${
              paymentId ? `&payment_id=${paymentId}` : ""
            }`
          );

          setLoading(false);
          setLimit(data?.data?.per_page);
          setPage(data?.data?.current_page);
          setTotal(data?.data?.total);
          setFrom(data?.data?.from);
          setTo(data?.data?.to);
          const receiptList = data.data.data;
          setReceiptsList(receiptList);
          return data.data;
        } catch (error) {
          setLoading(false);
          setReceiptsList([]);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParam, sortField, sortOrder, trustId, initialSubAssetId]
  );

  const receiptsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: receiptList[i]?.id,
        received_date: receiptList[i]?.receipt?.received_date
          ? receiptList[i]?.receipt?.received_date
          : "-",
        transaction_date: receiptList[i]?.receipt?.transaction_date
          ? receiptList[i]?.receipt?.transaction_date
          : "-",

        payment_method: receiptList[i]?.receipt?.payment_method
          ? receiptList[i]?.receipt?.payment_method == "5"
            ? "JE"
            : paymentMethods?.find(
                (item) =>
                  item.value === Number(receiptList[i]?.receipt?.payment_method)
              )?.label
          : "-",
        receipt_number: receiptList[i]?.receipt?.receipt_number
          ? receiptList[i]?.receipt?.receipt_number
          : "-",
        invoice_number: receiptList[i]?.receipt?.invoice_number
          ? receiptList[i]?.receipt?.invoice_number
          : "-",
        receipt_total: receiptList[i]?.receipt?.amount ? (
          <b>${formatNumber(Number(receiptList[i]?.receipt?.amount))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        amount: receiptList[i]?.amount ? (
          <b>${formatNumber(Number(receiptList[i]?.amount))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        used_amount: receiptList[i]?.used_amount ? (
          <b>${formatNumber(Number(receiptList[i]?.used_amount))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        remaining_balance: receiptList[i]?.remaining_balance ? (
          <b>${formatNumber(Number(receiptList[i]?.remaining_balance))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        amount_exc: receiptList[i]?.amount_exc ? (
          <b>${formatNumber(Number(receiptList[i]?.amount_exc))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        tax_amount: receiptList[i]?.tax_amount ? (
          <b>${formatNumber(Number(receiptList[i]?.tax_amount))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        description: receiptList[i]?.description
          ? receiptList[i]?.description
          : "-",
        vendor: receiptList[i]?.vendor
          ? formatSubcontractorName(receiptList[i]?.vendor)
          : "-",
        asset: receiptList[i]?.asset?.name ? receiptList[i]?.asset?.name : "-",
        sub_asset: receiptList[i]?.sub_asset?.name
          ? receiptList[i]?.sub_asset?.name
          : "-",
        contract: receiptList[i]?.contract
          ? receiptList[i]?.contract?.contract_number
          : "-",
        contact: receiptList[i]?.contact
          ? formatSubcontractorName(receiptList[i]?.contact)
          : "-",
        job: receiptList[i]?.ts_job?.code ? receiptList[i]?.ts_job?.code : "-",
        task: receiptList[i]?.ts_task?.code
          ? receiptList[i]?.ts_task?.code
          : "-",
        file_note: receiptList[i]?.receipt?.file_note
          ? receiptList[i]?.receipt?.file_note
          : "-",
        is_reversed: receiptList[i]?.receipt?.is_reversed,
        is_refund: receiptList[i]?.receipt?.is_refund,
        is_disposed: receiptList[i]?.receipt?.is_disposed,
        archived: receiptList[i]?.receipt?.archived,
        status: (
          <span>
            {receiptList[i]?.receipt?.archived === 1 ? (
              <>Revert</>
            ) : receiptList[i]?.receipt?.is_reversed === 1 ? (
              <>Reversed</>
            ) : receiptList[i]?.receipt?.is_refund === 1 ? (
              <>Refunded</>
            ) : receiptList[i]?.receipt?.is_disposed === 1 ? (
              <>Disposed</>
            ) : (
              <>Initial</>
            )}
          </span>
        ),
      });
    }
    return items;
  };

  const receipts = receiptsGenerator(receiptList?.length);

  const columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "received_date",
      text: "Received Date",
      sort: true,
      sortCaret,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "transaction_date",
      text: "Transaction Date",
      sort: true,
      sortCaret,
    },
    {
      headerClasses: cn(
        THClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      classes: cn(
        TDClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      dataField: "contact",
      text: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "contacts",
        "Customer"
      )}`,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "receipt_number",
      text: "Receipt Number",
      sort: true,
      sortCaret,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "invoice_number",
      text: "Invoice Number",
      sort: true,
      sortCaret,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "file_note",
      // text: "File Note",
      text: LawyerConditon(organizationData)
        ? "Matter Reference"
        : "File Note",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "amount",
      text: "Amount (Inc)",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "used_amount",
      text: "Used Amount",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "remaining_balance",
      text: "Remaining Balance",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "status",
      text: "Status",
    },
  ];

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC"
      );
    }
  };

  useEffect(() => {
    fetchReceipts();
  }, [fetchReceipts]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    []
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    debouncedSave(nextValue);
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchReceipts(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchReceipts(limit, page);
  };

  return (
    <>
      <MainBody
        search={false}
        searchParamData={searchParamData}
        handleClearSearch={handleClearSearch}
        handleSearchChange={handleSearchChange}
        actionContent={<></>}
        loading={loading}
        mainClassName="w-[calc(100%-3rem)]"
        expandList={true}
      >
        <div className="custom-table">
          <div className="table-body-class">
            <BootstrapTable
              keyField="key"
              remote
              data={receipts}
              columns={columns}
              onTableChange={handleTableChange}
              rowClasses={(row) => {
                if (row?.is_reversed) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                if (row?.is_refund) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                if (row?.is_disposed) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                if (row?.archived) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                return TRClasses;
              }}
              noDataIndication="No Data Found"
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>

          <Pagination
            total={total}
            limit={parseInt(limit)}
            currentPage={page}
            updateLimit={handleUpdateLimit}
            updatePage={handleChangePage}
            from={from}
            to={to}
          />
        </div>
      </MainBody>
    </>
  );
};

export default ReceiptItemsBasedOnSubAsset;
